import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';

import { TypeKeys } from '@common/react/store/Login';

import ContactUs from '@app/components/UI/ContactUs/ContactUs';
import CustomMenu from '@app/components/UI/Header/CustomMenu';
import { menuLoL } from '@app/components/UI/Header/MenuLoL';
import { menuMobile } from '@app/components/UI/Header/MenuMobile';
import { menuAuthorizedPHJ, menuUnauthorizedPHJ } from '@app/components/UI/Header/MenuPHJ';
import LoginForm from '@app/components/UI/Login/LoginForm';
import CustomModal from '@app/components/UI/Modal/CustomModal';
import LoginModal from '@app/components/UI/Modal/LoginModal';
import BarsSVG from '@app/images/icons/BarsSVG';
import CloseSVG from '@app/images/icons/CloseSVG';
import PHJLogoSVG from '@app/images/PHJLogoSVG';
import { ApplicationState } from '@app/store';

import { pushEvent } from '@app/components/TagManager';
import '@app/scss/components/login.scss';
import '@app/scss/headerNew.scss';

const HeaderNew: React.FC = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const login = useSelector((state: ApplicationState) => state.login, shallowEqual);
	const [isOpenNavbar, setIsOpenNavbar] = React.useState<boolean>(false);

	const [openContactForm, setOpenContactForm] = React.useState<boolean>(false);
	const [openLoginForm, setOpenLoginForm] = React.useState<boolean>(false);

	const closeNavbar = () => {
		setIsOpenNavbar(false);
	};

	const closeLoginModal = (bool: boolean) => {
		setOpenLoginForm(bool);
		dispatch({ type: TypeKeys.CLEARSTATE });
	};

	const openModal = (str: string) => {
		if (str === 'contact-form') {
			setOpenContactForm(true);
		} else if (str === 'sign-in') {
			setOpenLoginForm(true);
		}
	};

	React.useEffect(() => {
		closeNavbar();
	}, [location]);

	React.useEffect(() => {
		const html = window?.document?.querySelector('html');
		const body = window?.document?.querySelector('body');

		if (html && body) {
			isOpenNavbar ? html.style.overflowY = 'hidden' : html.style.overflowY = 'visible';
			isOpenNavbar ? body.style.overflowY = 'hidden' : body.style.overflowY = 'visible';
		}
	}, [isOpenNavbar]);

	return (
		<>
			<header className="site-header">
				<nav className="navbar navbar-fixed-top">
					<div className="navbar-wrapper">
						<div className="lol">
							<a className="lol__logo" href="https://www.lapoflove.com/" target="_blank" rel="noopener noreferrer">
								<img src={require('@app/images/extended-logo.svg')} alt="Lap of Love - logo" />
							</a>
							<div className="lol__nav">
								<CustomMenu items={menuLoL} closeMenu={closeNavbar} />
							</div>
							<div className="lol__btns">
								<a
									className="btn btn-purple-gray-border"
									href="https://www.lapoflove.com/online-booking"
									target="_blank"
									rel="noopener noreferrer"
									onClick={() => pushEvent('PHJ-ScheduleHeader')}
								>
									Schedule
								</a>
								<a className="btn btn-purple-gray" href="https://www.lapoflove.com/find-a-vet" target="_blank" rel="noopener noreferrer">
									Find a Vet
								</a>
							</div>
						</div>

						<div className="vertical-line" />

						<div className="phj">
							<div className="phj__logo">
								<NavLink to="/" onClick={closeNavbar}>
									<PHJLogoSVG />
									<span className="phj__logo-text">
										<span className="title">Pet Hospice Journal</span>
										<span className="subtitle">Helping families track pet quality of life</span>
									</span>
								</NavLink>
							</div>
							<div className="phj__nav">
								<CustomMenu items={login.user ? menuAuthorizedPHJ : menuUnauthorizedPHJ} closeMenu={closeNavbar} onChangeVisibleModal={openModal} />
							</div>
						</div>

						<div className="navbar-wrapper__icon" onClick={() => setIsOpenNavbar(!isOpenNavbar)}>
							{!isOpenNavbar ? <BarsSVG /> : <CloseSVG />}
						</div>

						<div className={`navbar-wrapper__nav-bar ${isOpenNavbar ? 'open' : 'no-open'}`}>
							<div className="navbar-wrapper__nav-bar__container">
								<CustomMenu items={menuMobile(Boolean(login.user))} closeMenu={closeNavbar} onChangeVisibleModal={openModal} />
							</div>
						</div>
					</div>
				</nav>
			</header>

			{openLoginForm && (
				<LoginModal modalVisible={openLoginForm} setModalVisible={closeLoginModal}>
					<LoginForm setModalVisible={closeLoginModal} />
				</LoginModal>
			)}

			{openContactForm && (
				<CustomModal modalVisible={openContactForm} setModalVisible={setOpenContactForm}>
					<ContactUs onChangeVisibleModal={setOpenContactForm} />
				</CustomModal>
			)}
		</>
	);
};

export default HeaderNew;
